import { useEffect, useState, useCallback } from 'react';
import api from 'api';
import { UserType } from 'types/user';

const useUsers = (id: string | number) => {
  const [user, setUser] = useState<UserType | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown>(null);

  const fetchUser = useCallback(async () => {
    if (id === null || id === undefined || id === '') return;
    try {
      setLoading(true);
      setError(null);
      const response = await api.getUserById(id);
      setUser(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return {
    user, loading, error, refetch: fetchUser,
  };
};

export default useUsers;
